<div class="readOnlyValue" [title]="outputValue" [textContent]="outputValue"></div>
